export const ROLE_PAGES = {
  'Super Admin': 'ALL',
  'Admin': [
    'dashboard','players','player-onboarding','player-requests','scouts','agents','clubs','organizers','community-groups','community-creation','mobile-marketplace','events','payments','payouts',
    'trial-applications','audit-trail','user-management','contacts','deals','pipeline',
    'tasks','workflows','meetings','call-log','sequences','inbox','tickets','reports',
    'activity-dashboard','sales-forecast','goals'
  ],
  'Finance': [
    'dashboard','payments','payouts','reports','sales-forecast','quotes','products',
    'activity-dashboard','goals'
  ],
  'Developer': [
    'dashboard','developer','integrations','permissions','audit-trail','custom-properties'
  ],
  'Product Manager': [
    'dashboard','players','player-onboarding','player-requests','scouts','clubs','organizers','community-groups','community-creation','mobile-marketplace','events','trial-applications','contacts',
    'pipeline','sequences','marketing-emails','lists','forms','landing-pages',
    'social-media','ads','sms','blog','ctas','reports','activity-dashboard'
  ],
  'Support': [
    'dashboard','mobile-marketplace','tickets','inbox','contacts','knowledge-base','live-chat',
    'help-support','calls'
  ],
};

export const ROLES = ['Super Admin','Admin','Finance','Developer','Product Manager','Support'];

export const canAccess = (role, page) => {
  const pages = ROLE_PAGES[role];
  if (!pages) return false;
  if (pages === 'ALL') return true;
  return pages.includes(page);
};

export const getDefaultPage = (role) => {
  const pages = ROLE_PAGES[role];
  if (!pages || pages === 'ALL') return 'dashboard';
  return pages[0] || 'dashboard';
};
